<template>
	<div class="public-content theme-management" ref="managementContent">
		<div class="region-title" style="background: #fff">云底片记录</div>
		<el-form :inline="true" :model="filterFormModel" class="filter-form-container">
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="店铺号:">
						<!-- <el-input v-model="formInline.code" placeholder="请输入店铺号"></el-input> -->
						<el-select clearable v-model="filterFormModel.queryStoreId" :filter-method="filterMethod" filterable placeholder="请输入店铺号">
							<el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.storeId"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="店铺名称:">
						<el-select clearable v-model="filterFormModel.queryStoreId" :filter-method="filterByName" filterable placeholder="请输入店铺名称">
							<el-option v-for="item in storeListByCode" :key="item.id" :label="item.shopName" :value="item.storeId"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6" v-if="$hasPermission('freight:admin:cloudFilmRecords:business')">
					<el-form-item label="业务:" prop="salesmanId">
						<el-select clearable v-model="filterFormModel.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
							<el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="状态:" label-width="54px">
						<el-select v-model="filterFormModel.status" placeholder="请选择" clearable>
							<el-option v-for="(label, value) in status" :key="value" :label="label" :value="value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="20">
					<el-form-item label="提交日期:">
						<el-date-picker v-model="filterFormModel.reservationDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="3">
					<el-form-item>
						<el-button round @click="handleSearch">查询</el-button>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="data-list">
			<el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border :row-class-name="rowClassName">
				<el-table-column min-width="100px" prop="code" label="店铺号"> </el-table-column>
				<el-table-column min-width="100px" prop="name" label="店铺名称">
				</el-table-column>
				<el-table-column min-width="80px" prop="salesmanName" label="业务">
				</el-table-column>
				<el-table-column min-width="100px" prop="phones" label="客户手机号">
				</el-table-column>
				<el-table-column min-width="100px" prop="photoNum" label="照片张数">
				</el-table-column>
				<el-table-column min-width="100px" prop="deliveryType" label="交付类型">
					<template v-slot="scope">
						<el-tag v-if="scope.row.deliveryType == 1" type="success">底片交付</el-tag>
						<el-tag v-else-if="scope.row.deliveryType == 2" type="warning">精修片交付</el-tag>
					</template>
				</el-table-column>
				<el-table-column min-width="80px" prop="effectiveDays" label="有效日期(天)">
				</el-table-column>
				<el-table-column min-width="100px" prop="createdTime" label="提交日期">
				</el-table-column>
				<el-table-column min-width="80px" prop="status" label="状态">
					<template v-slot="scope"> {{ scope.row.status == 'UPLOADING' ? '上传中' : scope.row.status == 'UPLOADED' ? '已上传' : scope.row.status == 'UNDOWNLOAD' ? '未下载' : scope.row.status == 'DOWNLOADED' ?
						'已下载' : '' }} </template>
				</el-table-column>
			</el-table>
		</div>
		<!--    分页-->
		<v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="fetchList"></v-pagination>
	</div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { getCloudFilmList } from '@/api/pms'
import { getSalesmanByFullName, getMembershipListForQuery } from '@/api/crm'
export default {
	name: 'cloudFilmRecords',
	components: {
		VPagination
	},
	data () {
		return {
			filterFormModel: {
				code: '',
				name: '',
				salesmanId: '',
				serviceType: '',
				status: '',
				page: 1
			},
			tableData: [],
			queryInfo: {
				pageNum: 1, // 当前显示第几页
				pageSize: 10, // 每一页显示条数
				total: 0
			},
			rememberScroll: null,
			status: {
				UPLOADING: '上传中',
				UPLOADED: '已上传',
				NOT_DOWNLOADED: '未下载',
				DOWNLOADED: '已下载'
			},
			salemanList: [],
			storeListByCode: []
		}
	},
	watch: {
		$route: {
			handler: function (newRoute, oldRoute) {
				console.log('当前路由：', newRoute)
				console.log('之前的路由：', oldRoute)
				if (newRoute.path == '/piya/cloudFilm') {
					this.filterFormModel.systemCode = 'PIYA'
				} else {
					this.filterFormModel.systemCode = ''
				}
				if (oldRoute && (oldRoute.path == '/piya/cloudFilm' || oldRoute.path == '/videoSeason/cloudFilm')) {
					this.fetchList()
				}
			},
			// 深度观察监听
			deep: true,
			immediate: true
		}
	},
	async mounted () {
		this.fetchList()
	},
	methods: {
		filterByName (val) {
			if (val.trim()) {
				getMembershipListForQuery({ name: val }).then(res => {
					if (res.data.success) {
						this.storeListByCode = res.data.data
					}
				})
			}
		},
		filterMethod (val) {
			if (val.trim()) {
				getMembershipListForQuery({ code: val }).then(res => {
					if (res.data.success) {
						this.storeListByCode = res.data.data
					}
				})
			}
		},
		selectSalemanList (val) {
			if (val.trim()) {
				getSalesmanByFullName(val).then(res => {
					if (res.data.success) {
						this.salemanList = res.data.data
					}
				})
			}
		},
		handleSearch () {
			this.queryInfo.pageNum = 1
			this.fetchList()
		},
		async fetchList () {
			try {
				if (this.filterFormModel.reservationDate) {
					this.filterFormModel.createTimeBegin = this.filterFormModel.reservationDate[0]
					this.filterFormModel.createTimeEnd = this.filterFormModel.reservationDate[1]
				} else {
					this.filterFormModel.createTimeBegin = ''
					this.filterFormModel.createTimeEnd = ''
				}
				const res = await getCloudFilmList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, vo: this.filterFormModel })
				if (res.status === 200 && res.data.success) {
					this.tableData = res.data.data.records
					this.queryInfo.total = res.data.data.total
				}
			} catch (error) {
				console.log(error)
			}
		},
		rowClassName ({ row, rowIndex }) {
			// 把每一行的索引放进row
			row.index = rowIndex
			// this.tableData[rowIndex].index = rowIndex
		}
	}
}
</script>
<style scoped lang="less">
.theme-management {
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	overflow-y: scroll;
	// overflow: auto;
	-webkit-overflow-scrolling: touch;

	// &::-webkit-scrollbar {
	//   display: none;
	// }
}

.filter-form-container {
	border-top: 1px solid #ececec;
	border-bottom: 1px solid #ececec;
	padding: 20px 40px 0;
}

.add-category {
	justify-content: space-between;
}

.keywords {
	.el-input {
		width: 180px;
	}
}
</style>
